import {
  findSubserviceAcrossTrades,
  getTradeDisplayName,
} from '../constants/mockData/allTrades';
import { getSubserviceDisplayLabel } from './getSubserviceDisplayLabel';

/** Customer-facing label for custom storefront inquiries (not the API slug `other`). */
export const CUSTOM_SERVICE_LABEL = 'Custom Service';

/**
 * @param {string | null | undefined} serviceType — API / Cosmos short_name
 * @param {{ inquiryKind?: 'wizard' | 'custom' | string }} [options]
 * @returns {string}
 */
export function resolveServiceTypeDisplayLabel(serviceType, options = {}) {
  if (options.inquiryKind === 'custom') {
    return CUSTOM_SERVICE_LABEL;
  }

  const slug = typeof serviceType === 'string' ? serviceType.trim() : '';
  if (!slug) return '—';

  if (slug === 'other') {
    return CUSTOM_SERVICE_LABEL;
  }

  return getTradeDisplayName(slug);
}

/**
 * Trade + subservice labels for inquiry analytics and account history.
 * @param {string} serviceType
 * @param {string | null | undefined} subServiceType
 * @param {string | null | undefined} targetServiceTitle
 * @param {'wizard' | 'custom' | string | undefined} inquiryKind
 * @param {Array<{ ServiceType?: string, SubServices?: Array<{ SubServiceType?: string, Title?: string }> }>} [enrolledServices]
 */
export function getInquiryDisplayNames(
  serviceType,
  subServiceType,
  targetServiceTitle,
  inquiryKind,
  enrolledServices,
) {
  if (inquiryKind === 'custom') {
    const subserviceName =
      (typeof targetServiceTitle === 'string' && targetServiceTitle.trim()) ||
      getSubserviceDisplayLabel(subServiceType, {
        serviceType: 'other',
        enrolledServices,
      }) ||
      '';
    return { tradeName: CUSTOM_SERVICE_LABEL, subserviceName };
  }

  const tradeName = resolveServiceTypeDisplayLabel(serviceType, { inquiryKind });
  const slug =
    typeof subServiceType === 'string' ? subServiceType.trim() : '';
  if (!slug) {
    return { tradeName, subserviceName: '' };
  }

  const title =
    typeof targetServiceTitle === 'string' ? targetServiceTitle.trim() : '';
  if (title) {
    return { tradeName, subserviceName: title };
  }

  const subserviceName =
    getSubserviceDisplayLabel(slug, { serviceType, enrolledServices }) ||
    findSubserviceAcrossTrades(slug)?.subservice?.label ||
    slug;

  return { tradeName, subserviceName };
}
